// v10/src/utils/checklist.js
// Helpers de checklist compartidos entre AircraftSelector (fase 1, prevuelo)
// y App.js (fases 2/3 — Sub-etapa 3.2b, continuar a la próxima fase).

// Transforma el checklist tal como lo devuelve el backend
// (GET /api/aircraft/:id?phase=...) a la forma que consume ChecklistDisplay.
// Movida acá desde AircraftSelector.js (Sub-etapa 3.2b) para poder pedir el
// checklist de fases 2/3 desde App.js sin duplicar la transformación.
export const transformChecklistFromBackend = (backendChecklist) => {
  if (!backendChecklist || !Array.isArray(backendChecklist)) return [];
  return backendChecklist.map(section => ({
    section: section.section,
    items: section.items.map(item => {
      const t = {
        text: item.text,
        description: item.description || '',
        referenceImage: item.reference_image_url || null,
        item_type: item.item_type || 'check',
      };
      if (item.has_suggestion && (item.suggestion_text || item.suggestion)) {
        t.suggestion = {
          text:   item.suggestion_text || item.suggestion?.text || '',
          detail: item.suggestion_detail || item.suggestion?.detail || '',
        };
      }
      return t;
    })
  }));
};

// Orden natural de fases — espejo de VALID_PHASES en
// condor360-backend/utils/validations.js.
export const PHASE_ORDER = ['prevuelo', 'puesta_en_marcha', 'prueba_motor'];

// Sub-etapa 3.2c-i: los copys de fase (nombre visible) se migraron a i18n
// (common.json, claves phase_prevuelo / phase_puesta_en_marcha /
// phase_prueba_motor) — PHASE_LABELS (solo-ES) queda reemplazado por
// t('phase_...') en los callers. Ver App.js (voz) y CompletionScreen.js
// (botón "Continuar con...").

export const PHASE_APPROVED_TITLES = {
  prevuelo:         'Prevuelo Aprobado',
  puesta_en_marcha: 'Puesta en marcha aprobada',
  prueba_motor:     'Prueba de motor aprobada',
};

// Deriva isLastPhase/nextPhase del plan de fases del chequeo actual —
// compartido entre el render (botón "Continuar con...") y la voz de cierre
// de handleChecklistComplete para no duplicar el cálculo (Sub-etapa 3.2c-i).
//
// skippedPhases (Sub-etapa 3.2c-ii, opcional, default []) — fases OPCIONALES
// que el piloto ya salteó en este chequeo. Se excluyen de la búsqueda de
// "próxima fase": si puesta_en_marcha ya se salteó, nextPhase pasa
// directamente a prueba_motor (o a null si no queda nada). A propósito NO
// se toca activePhase acá — activePhase sigue siendo la última fase
// REALMENTE ejecutada (para que el título "Prevuelo Aprobado" en
// CompletionScreen no cambie por un salteo, que no es una aprobación).
export const getPhaseProgress = (phasesPlan, activePhase, skippedPhases = []) => {
  const activePhaseIdx = phasesPlan.indexOf(activePhase);
  if (activePhaseIdx === -1) return { isLastPhase: true, nextPhase: null };
  const remaining  = phasesPlan.slice(activePhaseIdx + 1).filter(p => !skippedPhases.includes(p));
  const nextPhase  = remaining.length ? remaining[0] : null;
  const isLastPhase = nextPhase === null;
  return { isLastPhase, nextPhase };
};
